<template>
  <div class="complete">
    <!-- 车辆信息 -->
    <div class="vehicle">
      <div class="photos">
        <h2 class="c999 mt20 mb20">完工照片</h2>
        <van-uploader
          v-model="fileList"
          :max-count="6"
          :before-read="beforeRead"
          :before-delete="deletePhoto"
          :accept="'image/*'"
          multiple
        />
      </div>

      <div class="vehicleli">
        <div class="lileft font28 c000 flexc">车辆品牌</div>
        <div class="liright c333">
          <input
            type="text"
            name="carBrand"
            v-model="carBrand"
            placeholder="请填写"
          />
        </div>
      </div>
      <div class="vehicleli">
        <div class="lileft font28 c000 flexc">款式</div>
        <div class="liright c333">
          <input
            type="text"
            name="carStyle"
            v-model="carStyle"
            placeholder="请填写"
          />
        </div>
      </div>
      <div class="vehicleli">
        <div class="lileft font28 c000 flexc">行驶里程</div>
        <div class="liright c333">
          <input
            type="text"
            name="mileage"
            v-model="mileage"
            placeholder="请填写"
          />
        </div>
      </div>
    </div>
    <!-- 车辆信息end -->

    <!-- 最近消费记录 -->
    <div class="mt20 consumption" v-if="userOrders.length > 0">
      <div class="conTitle">
        <span class="titlex"></span>
        <div class="ml20 font32 c000">最近消费记录</div>
      </div>
      <div class="consumbody mt20">
        <div class="consumbodyli" v-for="item in userOrders">
          <div class="sonName">
            <span class="namelog"></span>
            <div class="nametext font26 ml10 c000">{{ item.serviceName }}</div>
          </div>
          <div class="contime c000 font24">{{ item.creatTime }}</div>
        </div>
      </div>
    </div>
    <!-- 推荐美容项目 -->
    <div class="mt20 consumption consumption1" v-if="pushCoupons">
      <div class="conTitle">
        <span class="titlex"></span>
        <div class="ml20 font32 c000">推荐美容项目</div>
      </div>

      <div class="prolist mt20">
        <van-radio-group v-model="recommendPro">
          <van-cell-group>
            <van-cell title="不推荐项目" clickable @click="recommendPro = '-1'">
              <template #right-icon>
                <van-radio name="-1" checked-color="#FFD100" />
              </template>
            </van-cell>

            <van-cell
              v-for="item in pushCoupons"
              :key="item.index"
              :title="item.couponsDesc"
              clickable
              @click="recommendPro = item.couponsId"
            >
              <template #right-icon>
                <van-radio :name="item.couponsId" checked-color="#FFD100" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <!-- <div class="prolistli"></div> -->
      </div>
    </div>

    <div class="mt20">
      <van-cell center title="24项检测">
        <template #right-icon>
          <van-switch
            v-model="checked"
            size="24"
            active-color="#FFD100"
            inactive-color="#dcdee0"
          />
        </template>
      </van-cell>
    </div>

    <!-- 评级 -->
    <div
      class="rating mt20"
      v-for="(rating, index) in rating"
      :key="index"
      v-if="checked"
    >
      <div class="ratingtitle c000 font32">
        <div class="ratbs"></div>
        <div class="ml10">{{ rating.name }}{{ rating[index] }}</div>
      </div>
      <div
        class="ratingli mt20"
        v-for="(list, indexlist) in rating.list"
        :key="indexlist"
      >
        <div class="ratingleft font28 c333 ml20">{{ list.name }}</div>
        <div class="ratingright font28">
          <div
            class="good ratingrightli"
            :class="{ activecom: list.level == '1' }"
            @click="evaluationOfLevel(index, indexlist, '1')"
          >
            优
          </div>
          <div
            class="medium ratingrightli"
            :class="{ activecom: list.level == '2' }"
            @click="evaluationOfLevel(index, indexlist, '2')"
          >
            良
          </div>
          <div
            class="poor ratingrightli"
            :class="{ activecom: list.level == '3' }"
            @click="evaluationOfLevel(index, indexlist, '3')"
          >
            差
          </div>
        </div>
      </div>
    </div>
    <!-- 评级 -->
    <!-- 按钮 -->
    <div class="successbtn btncolor photoenter" @click="uploadInformation">
      确定
    </div>
    <div class="cancelbtn mt20">取消</div>
    <!-- 按钮end -->
  </div>
</template>

<script>
import { RadioGroup, Radio, Toast, Switch, Dialog } from 'vant'

export default {
  name: 'complete', // 服务完成
  data () {
    return {
      imageupflg: false, // 检测图片是否上传完成
      recommendPro: '', // 推荐项目
      checked: false, // 车况开关
      upflag: true, // 上传控制开关
      photoData: [], // 服务完成图片
      carBrand: '', // 汽车品牌
      carStyle: '', // 汽车款式
      mileage: '', // 行驶里程
      fileList: [],
      imageUrls: [], // 接口发送的图片地址
      rating: [
        {
          name: '车身',
          list: [
            {
              name: '太阳膜',
              level: '2'
            },
            {
              name: '车漆',
              level: '2'
            },
            {
              name: '脚垫',
              level: '2'
            }
          ]
        },
        {
          name: '车灯',
          list: [
            {
              name: '前示宽灯',
              level: '2'
            },
            {
              name: '后示宽灯',
              level: '2'
            },
            {
              name: '前雾灯',
              level: '2'
            },
            {
              name: '后雾灯',
              level: '2'
            },
            {
              name: '大灯',
              level: '2'
            },
            {
              name: '转向灯',
              level: '2'
            },
            {
              name: '刹车灯',
              level: '2'
            },
            {
              name: '倒车灯',
              level: '2'
            }
          ]
        },
        {
          name: '油液面',
          list: [
            {
              name: '发动机油',
              level: '2'
            },
            {
              name: '制动液',
              level: '2'
            },
            {
              name: '助力油',
              level: '2'
            },
            {
              name: '冷却液',
              level: '2'
            }
          ]
        },
        {
          name: '刹车与轮胎',
          list: [
            {
              name: '刹车片',
              level: '2'
            },
            {
              name: '刹车盘',
              level: '2'
            },
            {
              name: '轮胎磨损',
              level: '2'
            },
            {
              name: '胎压',
              level: '2'
            }
          ]
        }
      ],
      userOrders: [], // 用户消费记录
      pushCoupons: [] // 推荐项目
    }
  },
  created () {
    console.log(this.$route.query)
    // this.orderId = this.$route.query.orderId
    // this.rating = datalist.datalist
  },
  mounted () {
    this.dataInfoBackfill()
    this.getPushCoupons()
  },
  methods: {
    // 信息回填
    dataInfoBackfill () {
      this.orderId = this.$route.query.orderId
      this.$api
        .HZrequest('/we-chat/gzh/user/carInfo', 'GET', {
          orderId: this.orderId
        })
        .then((res) => {
          if (res.data.carBrand) {
            this.carBrand = res.data.carBrand
            this.carStyle = res.data.carStyle
          }
        })
    },
    // 获取消费记录  获取推荐美容项目
    getPushCoupons () {
      this.$api
        .HZrequest('/we-chat/gzh/washer/pushCoupons/get', 'GET', {
          orderId: this.orderId
        })
        .then((res) => {
          this.userOrders = res.data.userOrders
          this.pushCoupons = res.data.pushCoupons
        })
    },

    // 评定等级
    evaluationOfLevel (ratindex, listindex, levelnum) {
      let that = this
      that.rating[ratindex].list[listindex].level = levelnum
    },
    // 上传前压缩图片
    async beforeRead (file) {
      if (file.length) {
        // file.length为真的时候说明是多图上传   要循环多图将file对象放进form中
        for (let i = 0; i < file.length; i++) {
          var f = await this.$api.compressImg(file[i]) // await只能放在async函数里 await会等待异步方法的返回值拿到以后在执行后面的方法
          var formData = new FormData()
          formData.append('file', f)
          this.$api.PHrequest('/oss/upload', 'POST', formData).then((res) => {
            this.imageUrls.push(res.data)
          })
        }
        this.imageupflg = true
      } else {
        let f = await this.$api.compressImg(file)
        var formData = new FormData()
        formData.append('file', f)
        this.$api.PHrequest('/oss/upload', 'POST', formData).then((res) => {
          this.imageUrls.push(res.data)
        })
        this.imageupflg = true
      }
      console.log(this.photoData[0])
    },

    deletePhoto (file, detail) {
      var index = detail.index
      // this.photoData.splice(index, 1)
      this.imageUrls.splice(index, 1)
      return true
    },
    // 上传车辆信息
    uploadInformation () {
      var that = this
      if (that.imageupflg == false) {
        // 图片还未上传完成
        Dialog.confirm({
          title: '',
          confirmButtonText: '立即提交',
          confirmButtonColor: '#ffd100',
          cancelButtonText: '继续等待',
          message: '图片还未上传完成，是否要立即提交'
        })
          .then(() => {
            // on confirm
            that.successUp()
          })
          .catch(() => {
            // on cancel
          })
        // Toast('图片上传中，请稍后')
        // return
      } else {
        that.successUp()
      }
    },

    // 上传完工信息
    successUp () {
      var that = this
      if (that.upflag == false) {
        return
      }

      Toast.loading({
        message: '上传中，请稍等',
        forbidClick: true,
        duration: 0
      })
      if (this.formValidation()) {
        that.upflag = false
        var options = JSON.stringify(this.rating)
        var data = {
          carBrand: this.carBrand,
          carStyle: this.carStyle,
          mileage: this.mileage,
          orderId: this.orderId,
          options: options,
          imageUrls: this.imageUrls,
          couponsId: this.recommendPro // 推荐项目
        }
        this.$api
          .HZrequest(
            '/we-chat/gzh/submit-service-completion-form',
            'POST',
            data
          )
          .then((res) => {
            if (res.code == 200) {
              setTimeout(function () {
                Toast('上传成功')
                that.upflag = true
                that.$router.replace({
                  path: '/service'
                })
              }, 800)
            } else {
              Toast('上传失败请重试')
              that.upflag = true
            }
          })
      }
    },

    // 验证为是否为空
    formValidation () {
      var that = this
      if (this.imageUrls.length <= 0) {
        Toast('请添加图片')
        return false
      }
      var carBrand = this.carBrand.replace(/\s*/g, '') // 将输入的内容去掉空格
      if (carBrand == '') {
        Toast('请填写车辆品牌')
        return false
      }
      var carStyle = this.carStyle.replace(/\s*/g, '') // 将输入的内容去掉空格
      if (carStyle == '') {
        Toast('请填写车辆款式')
        return false
      }
      var mileage = this.mileage.replace(/\s*/g, '') // 将输入的内容去掉空格
      var r = /^\+?[1-9][0-9]*$/
      var flag = r.test(mileage)
      if (mileage == '') {
        Toast('请填写车辆行驶里程')
        return false
      }
      if (flag == false) {
        Toast('行驶里程只能为正整数')
        return false
      }
      if (that.recommendPro == '' && that.pushCoupons.length > 0) {
        Toast('请勾选推荐项目')
        return false
      }
      for (let i = 0; i < that.rating.length; i++) {
        var list = that.rating[i].list
        for (let k = 0; k < list.length; k++) {
          var level = list[k].level
          var name = list[k].name
          if (level == '') {
            Toast('请对车辆' + name + '评级')
            return false
          }
        }
      }
      return true
    }
  }
}
</script>

<style>
.vehicle {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
}

.vehicleli {
  width: 100%;
  box-sizing: border-box;
  padding: 0.24rem;
  border-bottom: 1px solid #eee;
  display: flex;
}

.lileft {
  width: 1.24rem;
  height: 0.62rem;
  margin-left: 0.2rem;
}

.liright {
  display: flex;
  flex-wrap: wrap;
  width: calc(100% - 1.24rem);
}

.vehimg {
  width: 1.6rem;
  height: 1.6rem;
  margin-right: 0.24rem;
  position: relative;
}

.vehimg:nth-child(3n) {
  margin-right: 0;
}

.vehimg img {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 0.08rem;
}

.deletebtn {
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  top: 0;
  right: 0;
}

.flexc {
  display: flex;
  align-items: center;
}

.liright input {
  padding-left: 0.2rem;
  box-sizing: border-box;
  width: 100%;
}

.rating {
  background: #fff;
  box-sizing: border-box;
  width: 100%;
  padding: 0.24rem 0.34rem;
}

.ratbs {
  width: 0.06rem;
  height: 0.44rem;
  background: #ffc853;
  border-radius: 0.48rem;
}

.ratingtitle {
  display: flex;
  align-items: center;
}

.ratingli {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ratingright {
  width: 5.2rem;
  height: 0.6rem;
  display: flex;
  box-sizing: border-box;
  border-radius: 0.08rem;
  border: 1px solid #e5e5e5;
}

.ratingrightli {
  width: 33.33%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
}

.medium {
  box-sizing: border-box;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
}

.photoenter {
  margin-top: 1.48rem !important;
}

.activecom {
  background: #ffd100;
  color: #fff;
}

.photos {
  box-sizing: border-box;
  padding: 0 0.32rem;
}

.van-uploader__preview {
  margin: 0 0.09rem 0.09rem 0;
}

.van-uploader__preview-image {
  width: 1.6rem;
  height: 1.6rem;
}

.van-uploader__wrapper > div:nth-child(4n) {
  margin-right: 0;
}

.van-uploader__upload {
  width: 1.6rem;
  height: 1.6rem;
}
.consumption {
  background: #fff;
  box-sizing: border-box;
  padding: 0.24rem 0.32rem;
  padding-bottom: 0;
}
.consumption1 {
  padding: 0;
}
.consumption1 .conTitle {
  padding: 0.24rem 0.32rem;
  padding-bottom: 0;
  box-sizing: border-box;
}
.conTitle {
  width: 100%;
  display: flex;
  align-items: center;
}
.titlex {
  height: 0.44rem;
  width: 0.06rem;
  background: #ffd100;
}
.consumbody {
  width: 100%;
  padding: 0 0.24rem;
  box-sizing: border-box;
}
.consumbodyli {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0.2rem 0.1rem;
  border-bottom: 1px solid #eaeaea;
}
.consumbodyli:last-child {
  border: none;
}
.sonName {
  display: flex;
  align-items: center;
}
.namelog {
  border-radius: 50%;
  height: 0.14rem;
  width: 0.14rem;
  background: #ffd100;
}
.prolistli {
  width: 100%;
  height: 0.64rem;
  border-bottom: 2px solid #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/view/complete.vue